import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight, X, Zap } from "lucide-react";

/**
 * Shown when the API returns { upgradePrompt: true } (HTTP 402).
 *
 * Props:
 *   message  – the error string from the API (e.g. "Asset limit reached…")
 *   onClose  – callback to dismiss
 */
const UpgradeLimitModal = ({ message, onClose }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    onClose();
    navigate("/subscription");
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 flex flex-col gap-5">
        {/* Header */}
        <div className="flex items-start justify-between gap-3">
          <div className="w-11 h-11 rounded-xl bg-amber-50 flex items-center justify-center flex-shrink-0">
            <Zap className="w-5 h-5 text-amber-500" />
          </div>
          <button
            onClick={onClose}
            className="w-7 h-7 flex items-center justify-center rounded-full text-brand-muted hover:bg-gray-100 transition-colors flex-shrink-0 mt-0.5"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Body */}
        <div className="flex flex-col gap-1.5">
          <h2 className="text-base font-bold text-brand-text">Plan Limit Reached</h2>
          <p className="text-sm text-brand-muted leading-relaxed">
            {message || "You've reached the maximum allowed by your current plan."}
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-2">
          <button
            onClick={handleUpgrade}
            className="w-full h-10 rounded-xl bg-primary text-white text-sm font-semibold hover:bg-primary-dark transition-colors flex items-center justify-center gap-2"
          >
            <ArrowUpRight className="w-4 h-4" />
            Upgrade Plan
          </button>
          <button
            onClick={onClose}
            className="w-full h-10 rounded-xl border border-surface-border text-sm font-medium text-brand-muted hover:bg-surface transition-colors"
          >
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeLimitModal;
